import { tallyTokens } from "../../theme.tsx";
import React from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import AvatarPanel from "./AvatarPanel.tsx";
import ExplainPrompt from "./ExplainPrompt.tsx";
import ThumbUpPrompt from "./ThumbUpPrompt.tsx";
import ThumbDownPrompt from "./ThumbDownPrompt.tsx";
import SaveToDashboardPrompt from "./SaveToDashboardPrompt.tsx";
import { GridColDef } from "@mui/x-data-grid";
import { useTypedSelector } from "../../hooks.tsx";
import TableContent, { MAX_DEFAULT_VISIBLE_COLUMNS } from "./TableContent.tsx";

interface TablePromptProps {
  children?: React.ReactNode;
  content: {
    rows: Array<{ [key: string]: any }>;
    columns: GridColDef[];
    clarification?: string;
    default_visible_columns?: string[];
  };
  feedback?: string | null;
  exchange_id?: string;
}

const TablePrompt: React.FC<TablePromptProps> = ({
  feedback,
  exchange_id,
  content: { rows, columns, clarification, default_visible_columns },
}) => {
  const isLoggedIn = useTypedSelector((state) => state.authState.isLoggedIn);

  return (
    <Box marginBottom={"4%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid
          size={{ xs: 1, lg: 1 }}
          sx={{
            marginTop: "1%",
          }}
        >
          <AvatarPanel />
        </Grid>
        <Grid size={{ xs: 11, lg: 11 }}>
          <InputLabel
            sx={{
              color: tallyTokens.ink,
              whiteSpace: "normal",
            }}
          >
            <TableContent
              content={{
                rows,
                columns,
                clarification,
                default_visible_columns,
              }}
              gridOptions={{
                hideFooterSelectedRowCount: true,
                disableRowSelectionOnClick: true,
                initialPageSize: 10,
                pageSizeOptions: [10, 25, 50],
                showToolbar: true,
                maxDefaultVisibleColumns: MAX_DEFAULT_VISIBLE_COLUMNS,
              }}
            />
          </InputLabel>
        </Grid>
      </Grid>
      <Grid position={"relative"} sx={{ marginLeft: "8%", marginBottom: "5%" }}>
        <Grid container direction="row" position={"absolute"}>
          {feedback !== "bad" && (
            <Grid>
              <ThumbUpPrompt
                exchange_id={exchange_id}
                clicked={feedback === "good"}
              />
            </Grid>
          )}
          {feedback !== "good" && (
            <Grid>
              <ThumbDownPrompt
                exchange_id={exchange_id}
                clicked={feedback === "bad"}
              />
            </Grid>
          )}
          {isLoggedIn && (
            <Grid>
              <ExplainPrompt exchange_id={exchange_id} />
            </Grid>
          )}
          {isLoggedIn && (
            <Grid>
              <SaveToDashboardPrompt exchangeId={exchange_id} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TablePrompt;
